import type { Components } from '@mui/material';
import type { Theme } from '@mui/material/styles';

export const MuiIcon: Components<Omit<Theme, 'components'>>['MuiIcon'] = {
  styleOverrides: {
    colorPrimary: '#152232',
  },
};
